import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { postUserLocationUpdate } from '../../helpers/backend';

const LocationTracker = () => {
    // Attempt to get user. Adjust state selector based on actual Redux store structure.
    // Usually state.Login.user or state.Auth.user
    const user = useSelector(state => state.Login?.user || state.Auth?.user || state.Profile?.user);

    // Use a ref to store the last sent location to avoid sending duplicates if needed,
    // though the backend handles logic, preventing rapid-fire "same location" requests 
    // from the frontend can save battery/bandwidth.
    const lastLocation = useRef({ lat: 0, lng: 0 });
    const watchId = useRef(null);

    useEffect(() => {
        if (!user || !user.id || !navigator.geolocation) {
            return;
        }

        const success = (position) => {
            const { latitude, longitude } = position.coords;

            // Simple frontend optimization: don't send if exactly the same (floating point issues aside)
            // The backend has a 50m check, but we can avoid network calls for stationary.
            // For now, let's rely on backend as requested, but we'll log it.

            const payload = {
                latitude,
                longitude
            };

            // Send in background
            postUserLocationUpdate(user.id, payload)
                .then(() => {
                    // console.log("Location updated", payload);
                })
                .catch(err => {
                    console.error("Failed to update location", err);
                });
        };

        const error = (err) => {
            console.warn("Location tracking error:", err);
        };

        // Watch position
        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        watchId.current = navigator.geolocation.watchPosition(success, error, options);

        return () => {
            if (watchId.current !== null) {
                navigator.geolocation.clearWatch(watchId.current);
            }
        };
    }, [user]);

    return null; // This component renders nothing
};

export default LocationTracker;
